import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API } from '../../App';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { toast } from 'sonner';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';
import LayoutEditor from '../LayoutEditor';
import RequestsManager from '../RequestsManager';

export default function OrganizerLayoutEditor() {
  const { exhibitionId } = useParams();
  const navigate = useNavigate();
  const [exhibition, setExhibition] = useState(null);
  const [halls, setHalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [exhibitionId]);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const [exRes, hallsRes] = await Promise.all([
        axios.get(`${API}/exhibitions/${exhibitionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        }),
        axios.get(`${API}/halls?exhibition_id=${exhibitionId}`, {
          headers: { Authorization: `Bearer ${token}` }
        })
      ]);
      setExhibition(exRes.data);
      setHalls(hallsRes.data);
      setLoading(false);
    } catch (error) {
      toast.error('Veriler yüklenemedi');
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8">Yükleniyor...</div>;
  }

  if (!exhibition) {
    return <div className="p-8">Fuar bulunamadı</div>;
  }

  return (
    <div className="p-8" data-testid="organizer-layout-editor">
      <div className="mb-6">
        <Button 
          variant="outline" 
          onClick={() => navigate('/organizer')}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Fuarlara Dön
        </Button>
        <h1 className="text-3xl font-bold text-gray-900">{exhibition.name}</h1>
        <p className="text-gray-500 mt-1">Kroki düzenle ve talepleri yönet</p>
      </div>

      {halls.length === 0 ? (
        <Card>
          <CardContent className="py-12 text-center">
            <p className="text-gray-500 mb-4">Henüz hol eklenmemiş</p>
            <Button onClick={() => navigate(`/organizer/exhibition-wizard/${exhibitionId}`)}>
              Hol Ekle
            </Button>
          </CardContent>
        </Card>
      ) : (
        <Tabs defaultValue={halls[0]?.id || "layout"} className="w-full">
          <TabsList>
            {halls.map((hall) => (
              <TabsTrigger key={hall.id} value={hall.id} data-testid={`hall-tab-${hall.id}`}>
                {hall.name} ({hall.area_sqm.toFixed(0)} m²)
              </TabsTrigger>
            ))}
            <TabsTrigger value="requests" data-testid="requests-tab">Talepler</TabsTrigger>
          </TabsList>
          
          {halls.map((hall) => (
            <TabsContent key={hall.id} value={hall.id}>
              <LayoutEditor exhibition={exhibition} hall={hall} />
            </TabsContent>
          ))}
          
          <TabsContent value="requests">
            <RequestsManager exhibition={exhibition} />
          </TabsContent>
        </Tabs>
      )}
    </div>
  );
}